import React, { ReactNode, useEffect, useState } from "react";
import { Accept, useDropzone } from "react-dropzone";
import { sizeConversion } from "../helpers/GenericHelpers";
import { toast } from "react-toastify";
import FileItem from "../components/shared/FileItem";
import { fileUploadDefaults } from "../helpers/ModelHelpers";

interface IMultiUploadProps {
  files: any;
  handleFileChange: Function;
  displayInput: boolean; // display the input icon / label 
  className?: string;
  disabled?: boolean;
  accept?: Accept;
  maxSize?: number;
  maxFiles?: number;
  displayFilesContent?: boolean; // display the files content
  labelName?: ReactNode | string;
}

function MultiUpload(props: IMultiUploadProps) {
  const {
    files,
    handleFileChange,
    className,
    disabled,
    maxFiles,
    maxSize,
    accept,
    displayInput,
    displayFilesContent,
    labelName,
  } = props;

  
  const [errors, setErrors] = useState<any>();

  const removeFile = (e: any, file: any) => {
    const newFiles = files?.filter((each: any) => each?.path !== file?.path);
    handleFileChange(newFiles, true);
  };

  const onDrop = (acceptedFiles: any, fileRejections: any, event: any) => {
    handleFileChange(acceptedFiles);
    fileRejections?.length > 0 && setErrors(fileRejections);
  };

  useEffect(() => {
    if (errors && errors?.length > 0) {
      errors.forEach((err: any) => {
        err?.errors?.forEach((each: any) => {
          if (each?.code === "file-too-large" && maxSize) {
            toast.error(
              `Failed to upload. Size limit is ${sizeConversion(maxSize)}.`
            );
          } else if (each?.code === "file-invalid-type" && accept) {
            toast.error(
              `Valid formats for file upload are ${JSON.stringify(accept)}.`
            );
          } else {
            toast.error(each?.message);
          }
        });
      });
      setErrors([]);
    }
  }, [accept, errors, maxSize]);

  const {
    // acceptedFiles,
    // fileRejections,
    getRootProps,
    getInputProps,
  } = useDropzone({
    onDrop,
    disabled,
    maxFiles,
    maxSize,
    accept: accept || fileUploadDefaults.accept,
  });

  const displayAcceptedFileItems = () =>
    files.map((file: any) => <FileItem key={file?.path} file={file} removeFile={removeFile} />);

  const getClassName = () => {
    let value = "dropzone";
    if (className) value = value + " " + className;
    if (disabled) value = value + " disabled";
    if (displayFilesContent && files?.length > 0) {
      value = value + ' files'
    } else value = value + ' default'
    return value;
  };

  return (
    <div className="multi-file-container">
      { displayInput ? <div {...getRootProps({ className: getClassName() })}>
        <input {...getInputProps()} />
        {labelName ?? "Drag 'n' drop some files here, or click to select files"}
      </div> : <></> }
      {displayFilesContent && files ? (
        <div className="files-list">{displayAcceptedFileItems()}</div>
      ) : <></>}
    </div>
  );
}

export default MultiUpload;
